window.onload = function () {
    document.body.className = 'loaded';
    var trigger = document.querySelector('.menu-trigger');
    trigger.addEventListener('click', function () {
        document.body.classList.toggle('active-menu');
    });

    var menuLinks = document.querySelectorAll('.main-nav a');
    for (var i = 0; i < menuLinks.length; i++) {
        menuLinks[i].addEventListener('click', function() {
            document.body.classList.remove('active-menu');
        });
    }

};

 $(document).ready(function () {

$(".product-amount span").on("click", function() {

  var $button = $(this);

  var oldValue = $button.siblings("input").val();
  var input = $button.siblings("input");

  if ($button.hasClass('span-width-plus')) {
	  var newVal = parseFloat(oldValue) + 1;
	} else {
      var newVal = parseFloat(oldValue) - 1;
    } 

  let result = input.val(newVal);
  let line_number = $button.attr('data-line-item');

      fetch('/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
		async: true,
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(
          {
                'line': line_number,
                  'quantity': result.val()
                  }
                  ),
      })
      .then(response => {
        response.json();
      }).then((data) => {
		  location.reload(true);
	});  
});    
  });

